import { render, staticRenderFns } from "./VideoCards.vue?vue&type=template&id=13e3282d&scoped=true"
import script from "./VideoCards.vue?vue&type=script&lang=js"
export * from "./VideoCards.vue?vue&type=script&lang=js"
import style0 from "./VideoCards.vue?vue&type=style&index=0&id=13e3282d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e3282d",
  null
  
)

export default component.exports